import React, { useEffect, useState, useCallback } from 'react';
import { fetchParcaSiparisOzetBen, fetchParcaSiparisOzetAdmin, stokManuelGuncelle } from '../../services/stokV2Service';
import StokSiparisDetayFetchModal from './StokSiparisDetayFetchModal';
import StokGonderimDetayFetchModal from './StokGonderimDetayFetchModal';
import SiparisTaslakEkleModal from './SiparisTaslakEkleModal';
import TableListFooter from '../TableListFooter';
import IntegerInput from '../IntegerInput';
import { parseAdet } from '../../utils/integerInput';
import { MODAL_DEFAULT_LIMIT } from '../../constants/pagination';
import StokParcaCeridePanel from './StokParcaCeridePanel';
import './StokParcaSiparisGecmisiModal.css';

const getErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  const msg = error?.message || error?.data?.mesaj || error?.data?.message || fallback;
  return msg === 'Failed to fetch' ? 'Sunucuya bağlanılamadı' : msg;
};

const PAGE_SIZE = MODAL_DEFAULT_LIMIT;

const defaultOzet = () => ({
  eldeStok: 0,
  randevuCikis: 0,
  iadeFaturaCikis: 0,
  manuelCikis: 0,
  digerKatmanCikis: 0,
  digerCikis: 0,
});

const StokParcaSiparisGecmisiModal = ({
  open,
  onClose,
  mode = 'ben',
  teknikServisId,
  icerikId,
  parcaAdi,
  parcaKodu,
  mevcutAdet,
  ozAdet: ozAdetProp,
  parcaFiyat,
  onStokDegisti,
}) => {
  const [sayfa, setSayfa] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [siparisler, setSiparisler] = useState([]);
  const [sayfalama, setSayfalama] = useState({ toplam: 0, toplamSayfa: 0, mevcutSayfa: 1, limit: PAGE_SIZE });
  const [detaySiparisId, setDetaySiparisId] = useState(null);
  const [detayGonderimId, setDetayGonderimId] = useState(null);
  const [stokCikarOpen, setStokCikarOpen] = useState(false);
  const [stokCikarAdet, setStokCikarAdet] = useState('');
  const [stokCikarNot, setStokCikarNot] = useState('');
  const [stokCikarSubmitting, setStokCikarSubmitting] = useState(false);
  const [stokCikarError, setStokCikarError] = useState('');
  const [taslakEkleOpen, setTaslakEkleOpen] = useState(false);
  const [detayTab, setDetayTab] = useState('arsiv');

  const load = useCallback(async () => {
    if (!icerikId || !open) return;
    if (mode === 'admin' && !teknikServisId) {
      setSiparisler([]);
      setError('Teknik servis bilgisi eksik');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res =
        mode === 'admin'
          ? await fetchParcaSiparisOzetAdmin(teknikServisId, icerikId, { sayfa, limit: PAGE_SIZE })
          : await fetchParcaSiparisOzetBen(icerikId, { sayfa, limit: PAGE_SIZE });
      if (res?.basarili && res?.veri) {
        setSiparisler(res.veri.siparisler || []);
        setSayfalama(res.veri.sayfalama || { toplam: 0, toplamSayfa: 0, mevcutSayfa: sayfa, limit: PAGE_SIZE });
      } else {
        setSiparisler([]);
        setError(res?.mesaj || 'Veri alınamadı');
      }
    } catch (e) {
      setSiparisler([]);
      setError(getErrorMessage(e, 'Liste yüklenemedi'));
    } finally {
      setLoading(false);
    }
  }, [open, icerikId, teknikServisId, mode, sayfa]);

  useEffect(() => {
    if (open && icerikId) {
      setSayfa(1);
      setDetaySiparisId(null);
      setDetayGonderimId(null);
      setStokCikarOpen(false);
      setStokCikarAdet('');
      setStokCikarNot('');
      setStokCikarError('');
      setTaslakEkleOpen(false);
      setDetayTab('arsiv');
    }
  }, [open, icerikId]);

  useEffect(() => {
    if (open && icerikId) {
      load();
    }
  }, [open, icerikId, load]);

  const baslik = [parcaAdi || 'Parça', parcaKodu ? `(${parcaKodu})` : ''].filter(Boolean).join(' ');
  const cikarilabilirOz = Number(ozAdetProp != null ? ozAdetProp : mevcutAdet);
  const ozGecerli = Number.isFinite(cikarilabilirOz) && cikarilabilirOz >= 0;

  const handleStokCikarSubmit = async (e) => {
    e.preventDefault();
    if (!icerikId) return;
    const n = parseAdet(stokCikarAdet, {
      min: 1,
      max: ozGecerli ? cikarilabilirOz : undefined,
    });
    if (!n || n < 1) {
      setStokCikarError('Geçerli bir adet girin'); return;
    }
    if (ozGecerli && n > cikarilabilirOz) {
      setStokCikarError(`Öz stokta en fazla ${cikarilabilirOz} adet çıkarılabilir`); return;
    }
    setStokCikarSubmitting(true);
    setStokCikarError('');
    try {
      await stokManuelGuncelle({ icerikId, adet: -n, not: stokCikarNot || undefined });
      setStokCikarOpen(false);
      setStokCikarAdet('');
      setStokCikarNot('');
      if (typeof onStokDegisti === 'function') onStokDegisti();
      load();
    } catch (err) {
      setStokCikarError(getErrorMessage(err, 'İşlem yapılamadı'));
    } finally {
      setStokCikarSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div
        className="modal-overlay stok-parca-gecmis-modal"
        onClick={onClose}
        role="presentation"
      >
        <div className="modal-content stok-parca-gecmis-modal__content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <div>
              <h2>{baslik}</h2>
            </div>
            <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
              <i className="fas fa-times" />
            </button>
          </div>
          <div className="stok-parca-gecmis-modal__tabs">
            <button
              type="button"
              className={`stok-parca-gecmis-modal__tab${detayTab === 'arsiv' ? ' active' : ''}`}
              onClick={() => setDetayTab('arsiv')}
            >
              Arşiv
            </button>
            <button
              type="button"
              className={`stok-parca-gecmis-modal__tab${detayTab === 'siparis' ? ' active' : ''}`}
              onClick={() => setDetayTab('siparis')}
            >
              Sipariş geçmişi
            </button>
          </div>
          <div className="modal-body stok-parca-gecmis-modal__body">
            {detayTab === 'arsiv' ? (
              <StokParcaCeridePanel
                active={detayTab === 'arsiv'}
                mode={mode}
                teknikServisId={teknikServisId}
                icerikId={icerikId}
              />
            ) : (
              <>
            {error && <div className="alert alert-danger" style={{ marginBottom: '12px' }}>{error}</div>}
            {loading ? (
              <p className="stok-parca-gecmis-modal__hint">Yükleniyor…</p>
            ) : siparisler.length === 0 ? (
              <p className="stok-parca-gecmis-modal__hint">Bu parça için siparişle giriş kaydı bulunamadı.</p>
            ) : (
              <div className="stok-parca-gecmis-modal__table-wrap">
                <table className="admins-table stok-parca-gecmis-modal__ozet-table">
                  <thead>
                    <tr>
                      <th>Kaynak</th>
                      <th className="stok-ozet-col-num">Giriş</th>
                      <th className="stok-ozet-col-num">Randevu</th>
                      <th className="stok-ozet-col-num">İade</th>
                      <th className="stok-ozet-col-num">Stok günc.</th>
                      <th className="stok-ozet-col-num">Diğer</th>
                      <th className="stok-ozet-col-num">Elde</th>
                      <th className="stok-ozet-actions"> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {siparisler.map((s) => {
                      const oz = { ...defaultOzet(), ...(s.ozet || {}) };
                      const digerToplam = (oz.digerKatmanCikis || 0) + (oz.digerCikis || 0);
                      const isGonderim = s.kayitTipi === 'gonderim';
                      const rowKey = isGonderim
                        ? `gon-${s.gonderimId}`
                        : `sip-${s.siparisId}`;
                      const kaynakNo = isGonderim
                        ? (s.gonderimNumarasi || s.gonderimId)
                        : (s.siparisNumarasi || s.siparisId);
                      return (
                        <tr key={rowKey}>
                          <td>
                            <div className="stok-parca-gecmis-modal__sip-cell">
                              <span className="stok-parca-gecmis-modal__sip-no">
                                {kaynakNo}
                              </span>
                              {isGonderim ? (
                                <span className="stok-parca-gecmis-modal__badge stok-parca-gecmis-modal__badge--gonderim">
                                  Gönderim
                                </span>
                              ) : (
                                <>
                                  {s.siparisDurumu === 'IptalEdildi' && (
                                    <span className="stok-parca-gecmis-modal__badge stok-parca-gecmis-modal__badge--iptal">
                                      İptal
                                    </span>
                                  )}
                                </>
                              )}
                              <span
                                className={`stok-parca-gecmis-modal__badge stok-parca-gecmis-modal__badge--inline ${
                                  s.eldeStokVar
                                    ? 'stok-parca-gecmis-modal__badge--elde'
                                    : 'stok-parca-gecmis-modal__badge--tukendi'
                                }`}
                              >
                                {s.eldeStokVar ? 'Elde' : 'Tükendi'}
                              </span>
                            </div>
                            {s.ilkGirisTarihi && (
                              <div className="stok-parca-gecmis-modal__ilk-tarih">
                                {new Date(s.ilkGirisTarihi).toLocaleString('tr-TR', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                })}
                              </div>
                            )}
                            {isGonderim ? (
                              <div className="stok-parca-gecmis-modal__fiyat-inline stok-parca-gecmis-modal__fiyat-inline--konsinye">
                                Konsinye giriş
                              </div>
                            ) : (s.satirlar || []).length > 0 ? (
                              <div className="stok-parca-gecmis-modal__fiyat-inline">
                                {(s.satirlar || []).map((line, idx) => (
                                  <span key={idx}>
                                    {Number(line.birimMaliyet).toFixed(2)} ₺
                                    {(line.adet || 0) > 1 ? ` × ${line.adet}` : ''}
                                    {idx < (s.satirlar || []).length - 1 ? (
                                      <span className="stok-parca-gecmis-modal__fiyat-sep"> · </span>
                                    ) : null}
                                  </span>
                                ))}
                              </div>
                            ) : null}
                          </td>
                          <td className="stok-ozet-col-num">{s.girisAdet ?? 0}</td>
                          <td className="stok-ozet-col-num">{oz.randevuCikis}</td>
                          <td className="stok-ozet-col-num">{oz.iadeFaturaCikis}</td>
                          <td className="stok-ozet-col-num">{oz.manuelCikis}</td>
                          <td className="stok-ozet-col-num">{digerToplam}</td>
                          <td className="stok-ozet-col-num stok-ozet-col-num--elde">{oz.eldeStok}</td>
                          <td className="stok-ozet-actions">
                            <button
                              type="button"
                              className="category-action-btn edit-btn"
                              title={isGonderim ? 'Gönderim detayı' : 'Sipariş detayı'}
                              onClick={() => {
                                if (isGonderim) {
                                  setDetayGonderimId(s.gonderimId);
                                  setDetaySiparisId(null);
                                } else {
                                  setDetaySiparisId(s.siparisId);
                                  setDetayGonderimId(null);
                                }
                              }}
                            >
                              <i className={`fas ${isGonderim ? 'fa-truck-loading' : 'fa-file-alt'}`} />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {!loading && (
              <TableListFooter
                variant="compact"
                totalRecords={sayfalama.toplam ?? 0}
                currentPage={sayfalama.mevcutSayfa || sayfa}
                totalPages={Math.max(1, sayfalama.toplamSayfa || 1)}
                onPageChange={setSayfa}
                loading={loading}
              />
            )}
              </>
            )}
          </div>
          <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', flexWrap: 'wrap' }}>
            {mode === 'ben' && (
              <>
                <button
                  type="button"
                  className="secondary-btn"
                  onClick={() => setTaslakEkleOpen(true)}
                  disabled={!icerikId}
                >
                  <i className="fas fa-clipboard-list" style={{ marginRight: '6px' }} aria-hidden />
                  Sipariş taslağına ekle
                </button>
                <button
                  type="button"
                  className="primary-btn"
                  onClick={() => {
                    setStokCikarError('');
                    setStokCikarAdet('');
                    setStokCikarNot('');
                    setStokCikarOpen(true);
                  }}
                  disabled={!icerikId || !ozGecerli || cikarilabilirOz < 1}
                  title={
                    !ozGecerli || cikarilabilirOz < 1
                      ? 'Bu parçada çıkarılabilir öz stok yok (yalnızca öz stoktan çıkış yapılır)'
                      : 'Öz stoktan manuel çıkış'
                  }
                >
                  Stoktan çıkar
                </button>
              </>
            )}
            <button type="button" className="secondary-btn" onClick={onClose}>
              Kapat
            </button>
          </div>
        </div>
      </div>

      {stokCikarOpen && mode === 'ben' && (
        <div
          className="modal-overlay stok-parca-gecmis-modal stok-parca-gecmis-modal--nested"
          onClick={() => !stokCikarSubmitting && setStokCikarOpen(false)}
          role="presentation"
        >
          <div className="modal-content" style={{ maxWidth: '420px', width: '100%' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Stoktan çıkar</h2>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => !stokCikarSubmitting && setStokCikarOpen(false)}
                aria-label="Kapat"
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <form onSubmit={handleStokCikarSubmit}>
              <div className="modal-body">
                {stokCikarError && <div className="alert alert-danger" style={{ marginBottom: '12px' }}>{stokCikarError}</div>}
                <p style={{ margin: '0 0 12px', fontSize: '14px' }}>
                  <strong>{parcaAdi || 'Parça'}</strong>
                  {parcaKodu ? <span style={{ color: 'var(--text-gray)', marginLeft: '6px' }}>({parcaKodu})</span> : null}
                </p>
                <p style={{ margin: '0 0 12px', fontSize: '13px', color: 'var(--text-gray)' }}>
                  Manuel çıkış yalnızca <strong>öz stoktan</strong> yapılır; konsinye stok bu işlemle düşülmez.
                </p>
                {ozGecerli && (
                  <p style={{ margin: '0 0 12px', fontSize: '13px', color: 'var(--text-gray)' }}>
                    Çıkarılabilir öz stok: <strong>{cikarilabilirOz}</strong> adet
                  </p>
                )}
                <div className="form-group" style={{ marginBottom: '12px' }}>
                  <label htmlFor="stok-cikar-adet" style={{ fontWeight: 500, display: 'block', marginBottom: '6px' }}>
                    Çıkarılacak adet
                  </label>
                  <IntegerInput
                    id="stok-cikar-adet"
                    min={1}
                    max={ozGecerli ? cikarilabilirOz : undefined}
                    value={stokCikarAdet}
                    onChange={setStokCikarAdet}
                    allowEmpty
                    style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid var(--border-color, #dee2e6)' }}
                  />
                </div>
                <div className="form-group" style={{ marginBottom: '0' }}>
                  <label htmlFor="stok-cikar-not" style={{ fontWeight: 500, display: 'block', marginBottom: '6px' }}>
                    Not (isteğe bağlı)
                  </label>
                  <textarea
                    id="stok-cikar-not"
                    value={stokCikarNot}
                    onChange={(e) => setStokCikarNot(e.target.value)}
                    rows={2}
                    maxLength={500}
                    style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid var(--border-color, #dee2e6)', resize: 'vertical' }}
                  />
                </div>
              </div>
              <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                <button type="button" className="secondary-btn" disabled={stokCikarSubmitting} onClick={() => setStokCikarOpen(false)}>
                  Kapat
                </button>
                <button type="submit" className="primary-btn" disabled={stokCikarSubmitting}>
                  {stokCikarSubmitting ? 'Kaydediliyor…' : 'Çıkar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {detaySiparisId && (
        <StokSiparisDetayFetchModal siparisId={detaySiparisId} onClose={() => setDetaySiparisId(null)} />
      )}

      {detayGonderimId && (
        <StokGonderimDetayFetchModal gonderimId={detayGonderimId} onClose={() => setDetayGonderimId(null)} />
      )}

      <SiparisTaslakEkleModal
        open={taslakEkleOpen && mode === 'ben'}
        onClose={() => setTaslakEkleOpen(false)}
        parca={{
          icerikId,
          parcaAdi,
          parcaKodu,
          fiyat: parcaFiyat,
          gorunenFiyat: parcaFiyat,
        }}
        onSuccess={() => setTaslakEkleOpen(false)}
      />
    </>
  );
};

export default StokParcaSiparisGecmisiModal;
